import React, { Component } from 'react';
import { connect } from 'react-redux';

// Components
import VideoBlock from './components/VideoBlock/VideoBlock';
import Drawer from './components/DrawerSection/DrawerSection';

// Constants & Actions
import extActions from './redux/videoConsult.external';

// Styles && Images
import s from './VideoConsultation.style.js';

import { http } from "src/services/http";
import config from "config";




// Mock data
// import { testAppointmentsVerdonk } from '../../../__mock__/UG';


class VideoRoom extends Component {
  constructor() {
    super();
    this.state = {
      showDrawer: false,
      shouldPoll: true,
      isPatientReady: false,
    };
    this.triggerDrawer = this.triggerDrawer.bind(this);
    this.togglePolling = this.togglePolling.bind(this);
  }

  triggerDrawer() {
    this.setState({ showDrawer: !this.state.showDrawer });
  }

  togglePolling() {
    this.setState({ shouldPoll: !this.state.shouldPoll });
  }


  async getPatientVideoStatus(appointmentId) {
    try {
      const response = await http.get(`${config.gateway}video/roomStatus?roomName=${appointmentId}`);
      const status = response && response.data;

      (status === 'True' || status === true || status === 'true') ?
        this.setState({ isPatientReady: true }) :
        this.setState({ isPatientReady: false })
    } catch (error) {
      this.setState({ isPatientReady: false });
    }
  }

  async pollPatientVideoStatus(appointmentId) {
    if (this.state.shouldPoll) {
      await this.getPatientVideoStatus(appointmentId);
    }
  }

  componentDidMount() {
    const {
      appointment: { activeAppointment },
      match: { params },
      loadPatientById, loadWorkflowTimeline, loadAppointmentById
    } = this.props;

    if (activeAppointment.patient) {
      const { externalAppointmentId } = activeAppointment.appointment.entity;
      loadPatientById(activeAppointment.patient.externalId);
      loadWorkflowTimeline(externalAppointmentId);
    } else {
      // Poll every 10 seconds and change status
      this.getPatientVideoStatus(params.appointmentId);
      setInterval(() => { this.pollPatientVideoStatus(params.appointmentId) }, 10000)
      loadAppointmentById(params.appointmentId, loadPatientById);
    }
  }


  render() {
    const { showDrawer, isPatientReady } = this.state;
    const { appointment: { activeAppointment } } = this.props;
    const activeAppoint = activeAppointment;

    return activeAppoint ?
      <s.RoomWrapper>
        <VideoBlock
          id={activeAppoint && activeAppoint.id}
          doctor={activeAppoint && activeAppoint.practitioner}
          patient={activeAppoint && activeAppoint.patient}
          triggerDrawer={this.triggerDrawer}
          togglePolling={this.togglePolling}
          showDrawer={showDrawer}
          isPatientReady={isPatientReady}
        />

        <Drawer
          appoint={activeAppoint}
          showDrawer={showDrawer}
          triggerDrawer={this.triggerDrawer}
        />
      </s.RoomWrapper>
      :
      null;
  }
}

const mapStateToProps = state => ({
  appointment: state.practitioner.appointment,
  common: state.practitioner.common,
});

const mapDispatchToProps = dispatch => ({

  // updateCommonFilters: dataObj => dispatch(updateCommonFilters(dataObj)),
  // push: path => dispatch(push(path))

  // external
  loadPatientById: (data) => dispatch(extActions.loadPatientById(data)),
  loadWorkflowTimeline: (data) => dispatch(extActions.loadWorkflowTimeline(data)),
  loadAppointmentById: (data) => dispatch(extActions.loadAppointmentById(data))
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(VideoRoom);
